import { render, staticRenderFns } from "./BedRailAction.vue?vue&type=template&id=49afc21e&scoped=true&"
import script from "./BedRailAction.vue?vue&type=script&lang=js&"
export * from "./BedRailAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49afc21e",
  null
  
)

export default component.exports